"use client"

import { Ungroup } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UngroupIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UngroupIcon = component(Icon)({ as: Ungroup })
